import store from "store"
import {
  apiAction,
  setIsSignedInStateInLocalStorage,
  setRefreshToken,
  // setSignedInStateInLocalStorage
} from "store/middleware/api"
import {
  // setApiResponse,
  SET_AUTHENTICATED,
  SET_USER,
  SET_AUTH_TIME_STAMP,
  LOGOUT_USER
} from "store/modules/auth"
import {
  loadDictionary,
  // loadProductCategories,
  setLoginCalls,
  getAllClients,
  getAllClientsOptions,
  getAllAgents,
  getRankingOptions
} from "store/modules/backData"
import { loadClientAddresses, setClientTypeGlobal } from "store/modules/company"
import { getCart } from "store/modules/shop"
import { toastr } from "react-redux-toastr"
import { setUserInfo } from "store/modules/user"
import { history } from "utils/history"
import { loadOrganizationLists } from "store/justActions/lists"
import { resetDV } from "store/modules/dataView"
// import { searchStuff } from "store/modules/dataView.search"
import { printError } from "utils/printError"
import { arrayPartialMatch } from "utils/arrayUtils"
import { getLoginErrorToastMessage } from "utils/toastUtils"
// import { setOnBehalfIdInState } from "store/modules/page"

export const loadMe = ({ auth = false }) =>
  apiAction({
    endPoint: "/me", ///uniprest/user
    method: "GET",
    onSuccess: (data, dispatch) => {
      dispatch(loadOrganizationLists())
      dispatch(
        setUserInfo({
          id: data?.id,
          userId: data?.user?.id,
          name: data?.name,
          organizationId: data?.organizationId,
          language: "EN" //data?.user?.language
        })
      )

      //debugger
      // auth && dispatch(loadClientAddresses(data?.user.organizationId))
      return { type: "a" }
    },
    onFailure: (err) => {
      printError("loadMe()", err)
      // showMagicToaster({title: err})

      return {
        type: "a"
      }
    }
  })

// Shared post-login success handling. Runs after a plain sign-in (user without
// 2FA) AND after a successful 2FA code confirmation — both return the same
// LoginResultMsg (role + refreshToken), so the frontend treats them identically.
const applyLoginSuccess = (data, dispatch, noRedirect) => {
  setRefreshToken(data?.refreshToken)
  setIsSignedInStateInLocalStorage(true);//loginName !== "anonymous"
  dispatch(setUserInfo({ groupId: data?.role?.groupId }))
  dispatch(loadMe({ auth: true }))//loginName !== "anonymous"
  dispatch(setLoginCalls(0))
  dispatch(getCart())

  // dispatch( /***** moved to App.js for non logged users */
  //   searchStuff({
  //     type: "public/organization/workplace",
  //     dictionary: "LOCATION_RESPONSE",
  //     searchTerm: null,
  //     reload: true
  //   })
  // )

  // dispatch({ type: SET_AUTHENTICATED, payload: noRedirect ? null : true })
  // dispatch({ type: SET_AUTH_TIME_STAMP, payload: new Date() })
  // dispatch( setApiResponse(data));
  //app set-up
  // dispatch(loadEnums("product.ProductStockStatus"))
  // dispatch(loadEnums("user.UserStatus"))
  dispatch(
    setClientTypeGlobal("SMALL")//loginName === "anonymous" ? "GUEST" :
  )
  // dispatch(setClientTypeGlobal("RESELLER"))
  // dispatch(setClientTypeGlobal("LARGE"))
  // dispatch(setClientTypeGlobal("ADMIN"))
  //dispatch(loadProductCategories())/***** moved to App.js for non logged users */
  // dispatch(loadDictionary("PRODUCT_BRAND"))/***** moved to App.js for non logged users */
  // dispatch(loadDictionary("PRODUCT_SUPPLIER"))/***** moved to App.js for non logged users */
  // dispatch(loadDictionary("USER_POSITION"))/***** moved to App.js for non logged users */
  // dispatch(loadDictionary("UNIT_OF_MEASURE"))/***** moved to App.js for non logged users */
  dispatch(loadDictionary("UNIT_OF_MEASURE_CUSTOMER_OFFER"))
  // dispatch(loadDictionary("COUNTY"))/***** moved to App.js for non logged users */
  dispatch(getAllClients())
  dispatch(getAllClientsOptions())
  dispatch(getAllAgents())
  dispatch(getRankingOptions())/***** moved to App.js for non logged users */
  dispatch(resetDV())
  // dispatch(setOnBehalfIdInState())/***** moved to App.js for non logged users */
  dispatch({ type: SET_AUTHENTICATED, payload: noRedirect ? null : true })
  dispatch({ type: SET_AUTH_TIME_STAMP, payload: new Date() })
  if (!noRedirect) {
    setTimeout(() => {
      history?.push?.(
        arrayPartialMatch(data?.role?.permissions,
          ["WEBSHOP_ADMIN", "WEBSHOP_HR_ADMIN", "WEBSHOP_MARKETING_ADMIN"])
        ? "/admin"
        : "/shop/dashboard"
      )
      //history?.push?.(data?.role?.groupName === "Sales Manager" || data?.role?.groupName === "BO Sales" ? '/admin' : '/shop/dashboard')
    }, 3000)
    // setInterval(() => {
    //     dispatch(refreshJavaToken())
    // }, 5000);
  }
  return {
    type: SET_USER,
    payload: data
  }
}

// 2FA: the backend signals that a code was emailed by responding to /public/sign-in
// with HTTP 401 AND body.result === "LOGIN_TWO_FA" (looks exactly like a wrong
// password on the wire — must inspect result, not just the status code).
export const LOGIN_TWO_FA = "LOGIN_TWO_FA"

// options.onTwoFaRequired(loginName) — called when the backend asks for the emailed
// code instead of logging the user in. The caller shows the code-entry screen; no
// error toast is shown in that case.
export const javaLogin = (loginName, password, noRedirect, options = {}) =>
  apiAction({
    endPoint: "/public/sign-in",//login
    method: "POST",
    data: {
      loginName,
      password,
      client: "front"
    },
    onSuccess: (data, dispatch) => applyLoginSuccess(data, dispatch, noRedirect),
    onFailure: (e) => {

      // 2FA required: NOT an error — go to the code screen instead of toasting.
      if (
        e?.response?.status === 401 &&
        e?.response?.data?.result === LOGIN_TWO_FA
      ) {
        options?.onTwoFaRequired?.(loginName)
        return {
          type: "a"
        }
      }

      printError("javaLogin()", e)

      const errorMessage = getLoginErrorToastMessage(e)
      toastr.error(errorMessage)

      return {
        type: "a"
      }
    }
  })

// Completes a 2FA login after javaLogin returned LOGIN_TWO_FA. On success it runs
// the exact same post-login flow as a normal sign-in.
// options.onInvalidCode() — called on HTTP 400 error.twoFAInvalidCode (wrong /
// used / expired code); the caller keeps the user on the code screen for a retry.
export const confirmTwoFa = (loginName, code, noRedirect, options = {}) =>
  apiAction({
    endPoint: "/public/confirm-two-fa",
    method: "POST",
    data: {
      loginName,
      code,
      client: "front"
    },
    onSuccess: (data, dispatch) => applyLoginSuccess(data, dispatch, noRedirect),
    onFailure: (e) => {

      printError("confirmTwoFa()", e)

      // Wrong / already-used / expired code — a single generic outcome the backend
      // does not distinguish. Let the user retry on the same screen.
      if (
        e?.response?.status === 400 &&
        e?.response?.data?.localizationCode === "error.twoFAInvalidCode"
      ) {
        options?.onInvalidCode?.()
        return {
          type: "a"
        }
      }

      const errorMessage = getLoginErrorToastMessage(e)
      toastr.error(errorMessage)
      options?.onError?.()

      return {
        type: "a"
      }
    }
  })

export const resetPassword = (
  nPass,
  nPassAgain,
  passwKey,
  setSuccsessReset,
  setenterNewPasswordCard
) => {
  return apiAction({
    endPoint: "/public/password-reset",
    method: "POST",
    data: {
      newPassword: nPass,
      newPasswordAgain: nPassAgain,
      key: passwKey
    },
    onSuccess: (data, dispatch) => {
      setSuccsessReset(true)
      setenterNewPasswordCard(false)
      return {
        type: "a"
      }
    },
    onFailure: (error, dispatch) => {
      printError("resetPassword()", error)
      if (nPass !== nPassAgain) {
        toastr.error("Parolele nu se potrivesc!")
      } else {
        toastr.error(
          "Parola nouă nu se potrivește cerințelor minime de complexitate"
        )
      }
      return {
        type: "a"
      }
    }
  })
}

export const forgotPassword = (
  identity,
  setResetPasswordCard,
  setSentResetPasswordMessae,
  setLoginCard
) => {
  return apiAction({
    endPoint: "/public/password-forgot",
    method: "POST",
    data: {
      emailAddress: identity,
      client: "front"
    },
    onSuccess: (data, dispatch) => {
      setResetPasswordCard(false)
      setSentResetPasswordMessae(true)
      setLoginCard(false)
      return {
        type: "a"
      }
    },
    onFailure: (error, dispatch) => {
      printError("forgotPassword()", error)
      toastr.error("Utilizatorul nu exista!")
      return {
        type: "a"
      }
    }
  })
}

export const refreshJavaToken = () => {
  const rftok = store.getState().auth?.userData?.refreshToken
  return apiAction({
    endPoint: "/public/refresh-secure",
    method: "POST",
    data: {
      rftok
    },
    qs: true,
    onSuccess: (data, dispatch) => {
      return {
        type: "a"
        // payload: data
      }
    },
    onFailure: (error, dispatch) => {
      printError("refreshJavaToken()", error)
      // When refresh token fails, throw out the user and go to login page
      dispatch({ type: LOGOUT_USER })
      history?.push?.("/login")

      return {
        type: "a"
      }
    }
  })
}

// not used anymore, check clearCookieToken()
// 
//
// export const removeJavaToken = () => {
//   setIsSignedInStateInLocalStorage(false);
//   return apiAction({
//     endPoint: "/logout",
//     method: "POST",
//     onSuccess: (data) => {
//       setTimeout(() => {
//         history?.push?.("/")
//       }, 1000)
//       return {
//         type: "a"
//       }
//     },
//     onFailure: (error, dispatch) => {
//       printError("removeJavaToken()", error)
//       return {
//         type: "a"
//       }
//     }
//   })
// }
